import type { Data } from '@repo/strapi-types'
import { NavbarColumnGroup } from '@/components/elementary/navbar/NavbarColumnGroup'
import { Paragraph } from '@/components/typography/Paragraph'
import { NavigationMenuContent } from '@/components/ui/navigation-menu'

interface NavbarMenuPanelProps {
	readonly columns: Data.Component<'layout-utilities.navbar-item'>['columns']
}

export function NavbarMenuPanel({ columns }: NavbarMenuPanelProps) {
	return (
		<NavigationMenuContent className="lg:left-1/6 lg:-translate-x-1/6 xl:left-0 xl:translate-x-0 z-20">
			<ul className="bg-peach-100 rounded-md p-3 flex gap-4">
				{columns?.map((column) => (
					<li
						key={column.id}
						className="flex flex-col gap-4 bg-neutral-light-100 rounded-sm p-5 w-60"
					>
						{column.title && (
							<Paragraph
								fontSize="bodyRegularExtraSmall"
								textColor="gray"
								className="pb-5 uppercase border-b border-b-neutral-300"
							>
								{column.title}
							</Paragraph>
						)}

						{column.groups?.map((group) => (
							<NavbarColumnGroup key={group.id} group={group} />
						))}
					</li>
				))}
			</ul>
		</NavigationMenuContent>
	)
}
